module.exports = __webpack_public_path__ + "img/ic_plus.f68ed33a.svg";